<template>
  <CollapsibleCard
    :editable="editable"
    :editing="editing"
  >
    <template v-slot:header> Anmälan </template>

    <template v-slot:info>
      {{ applicationStateName }} (status)
      <template v-if="selectedApplication.regiongit"> , {{ selectedApplication.region.name }} (BYN-Region) </template>
    </template>

    <template v-slot:detailsinfo></template>

    <template v-slot:editinfo>Status och region.</template>

    <template v-slot:view>
      <ApplicationStatusView :stateName="applicationStateName" />
    </template>

    <template v-slot:edit>
      <ApplicationStatusEdit
        v-model="obj"
        ref="edit"
        @saved="$emit('saved')"
      />
    </template>

    <template v-slot:cancel>
      <v-btn
        color="secondary"
        @click="cancelEdit"
      >
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
    </template>

    <template v-slot:save>
      <v-btn
        :disabled="(selectedApplication.stateId === obj.stateId && obj.regionId==selectedApplication.regionId)"
        data-cy="update-status"
        @click="$refs.edit.saveObj()"
      >
        <v-icon>$sl-check</v-icon>Spara
      </v-btn>
    </template>

  </CollapsibleCard>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import CollapsibleCard from '@/components/common/CollapsibleCard'
import ApplicationInfoModal from '@/components/application/ApplicationInfoModal'
import pick from 'lodash/pick'
import get from 'lodash/get'
import ChangeStatusModal from '@/components/application/ChangeStatusModal'
import ApplicationStatusView from './ApplicationStatusView.vue'
import ApplicationStatusEdit from './ApplicationStatusEdit.vue'

// @group Application
export default {
  name: 'ApplicationStatus',

  props: {
    // Should fields be disabled
    disabled: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ChangeStatusModal,
    CollapsibleCard,
    ApplicationInfoModal,
    ApplicationStatusView,
    ApplicationStatusEdit
  },

  data: () => ({
    columns: ['id', 'stateId', 'regionId'],
    obj: null,
    editing: null
  }),

  created() {
    this.obj = pick(this.selectedApplication, this.columns)
    //console.log("created::",this.selectedApplication.id)
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'applicationCompany', 'isCompanyApplication']),
    ...mapGetters('basic', ['basicRegions']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    applicationStateName() {
      const application = this.selectedApplication
      let text = application?.state?.name

      if ( application?.transferOldProfession && application?.stateId !== 1 ) {
        if ( !application?.transferOldProfessionApproved ) {
          text = 'Förflyttning bekräftad av lärling'

          if ( application?.state?.id === 7 ) 
            text = 'Förflyttning bekräftad och godkänd av företag'
          
          if ( application?.transferApprovedById && !application?.transferApprovedBySecondaryId ) {
            text = 'Granskad och godkänd förflyttning'
          }
        } else {
          text = 'Klar'
        }
      }

      return text
    }
  },

  methods: {
    ...mapActions('application', ['updateSelectedApplication']),

    get,

    canEdit() {
      return (
        Boolean(this.obj && this.obj.id) &&
        Boolean(this.currentUser.userrole.isAdmin || this.currentUser.userrole.isRegistry)
      )
    },

    cancelEdit() {
      console.log('ApplicationObjs - cancelEdit')
      this.obj = pick(this.selectedApplication, this.columns)
      this.editing = false
    }
  }
}
</script>

<style>
</style>
